import * as React from 'react';
import WelcomePageHeroBanner from '../../api/welcomePageHeroBannerEntity';

interface IProps {
    welcomePageHeroBanner: WelcomePageHeroBanner;
    fetchWelcomePageHeroBanner(): void;
}

export class HeroBanner extends React.Component<IProps,{}> {
  public componentDidMount() {
    this.props.fetchWelcomePageHeroBanner();
  }

  public render() {
    let backgroundImageStyle = {};

    if (this.props.welcomePageHeroBanner.bannerBackgroundImage !== "") {
        backgroundImageStyle = {
            backgroundImage: "url(" + this.props.welcomePageHeroBanner.bannerBackgroundImage + ")",
            backgroundSize: '100%'
        }
    }

    return (
        <div className="hero" style={backgroundImageStyle}>
            <div className="text">
            <h1>{this.props.welcomePageHeroBanner.titleText}</h1>

            <a href={this.props.welcomePageHeroBanner.linkUrl} target={this.props.welcomePageHeroBanner.linkUrlTarget} title={this.props.welcomePageHeroBanner.linkText}>{this.props.welcomePageHeroBanner.linkText}</a>
            
            </div>
        </div>
    );
  }
};


// WEBPACK FOOTER //
// ./src/components/welcomePageHeroBanner/welcomePageHeroBanner.tsx